/**
 * <before-after> — draggable comparison slider.
 *
 * Loaded only by the section that uses it. The markup already shows both images
 * stacked without JS, so the section degrades to "two pictures" rather than
 * breaking.
 */

class BeforeAfter extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('input[type="range"]');
    if (!this.range) return;

    this.setPosition(this.range.value);

    this.range.addEventListener('input', () => this.setPosition(this.range.value));

    // Dragging anywhere on the image feels more natural than only on the handle.
    this.addEventListener('pointerdown', this.onPointerDown);
  }

  onPointerDown = (event) => {
    if (event.target === this.range) return;
    this.setPositionFromPointer(event);

    const onMove = (moveEvent) => this.setPositionFromPointer(moveEvent);
    const onUp = () => {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
    };

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  };

  setPositionFromPointer(event) {
    const { left, width } = this.getBoundingClientRect();
    const percent = ((event.clientX - left) / width) * 100;
    const clamped = Math.min(100, Math.max(0, percent));
    this.range.value = clamped;
    this.setPosition(clamped);
  }

  setPosition(value) {
    this.style.setProperty('--position', `${value}%`);
  }
}

customElements.define('before-after', BeforeAfter);
